/* eslint-disable max-len */
import ElectronicPartsRepair from 'pages/BackOfficePage/BackOfficeCategories/ElectronicPartsRepair/ElectronicPartsRepair';

export default ElectronicPartsRepair;
